module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" viewBox=\"0 0 32 32\"><path d=\"M0.622 18.334h19.54v7.55l11.052-9.412-11.052-9.413v7.549h-19.54v3.725z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/order-list.svg
// module id = 17
// module chunks = 0